const RateandTaxes = () => {
    return (
        <>
            <section>
                <div className="container-fluid">
                    <img src="images/innerbanner.webp" className='img-fluid' alt="" />
                </div>
            </section>

            {/* MAIN SECTION */}
            <section className="main-section">
                <div className="container">
                    <div className="row g-4">

                        {/* CONTENT */}
                        <div className="col-lg-9">

                            {/* Welcome */}
                            <div className="bg-white rounded-3 p-4 mb-4 shadow-sm">

                                <h2 className="section-title">
                                    Rate & Taxes
                                </h2>
                                <h3 className="h5" style={{ color: 'var(--red)' }}>
                                    For Rates & Taxes Please contact:
                                </h3>
                                <p className="welcome-text">
                                    011 - 41606842 , 096432 32088
                                </p>
                            </div>

                        </div>

                        <div className="col-md-3">
                            <div className="contact-card">
                                <div className="contact-title">Head Office</div>
                                <h3 className="h5" style={{ color: 'var(--red)' }}>
                                    Oxford Express Private Limited
                                </h3>
                                <p><b>B-9 Laxmi Bhawan 72, Nehru place New Delhi - 110019.</b></p>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </>
    )
}

export default RateandTaxes